import type { Address } from "viem"
import type { Config } from "wagmi"

import type { TransactionReturnType } from "@/domains/on-chain/types"
import { withdrawTokensFromExpiredVe } from "@/domains/on-chain"

import type { IWithdrawTokensFromExpiredVeActions } from "./interfaces"

/**
 * Adapter that implements IWithdrawTokensFromExpiredVeActions using the actual on-chain functions.
 * This is the production implementation injected into the interaction.
 */
export class WithdrawTokensFromExpiredVeActionsAdapter implements IWithdrawTokensFromExpiredVeActions {
  async withdrawTokensFromExpiredVe(params: {
    account: Address
    chainId: number
    config: Config
    vestedAddress: Address
    tokenId: number
  }): Promise<TransactionReturnType> {
    return await withdrawTokensFromExpiredVe(params)
  }
}
